import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { NewsSearchProvider } from './context/news-search-context';
import { NewsSearchComponent } from './news-search-component';

export function NewsSearchFactory() {
    return (
        <BaseLayoutFactory>
            <NewsSearchProvider>
                <NewsSearchComponent />
            </NewsSearchProvider>
        </BaseLayoutFactory>
    );
}
